import type React from 'react';
import { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { SearchableDropdownField } from 'ui-components/components/dropdown';
import type { DropdownOption } from 'ui-components/components/dropdown/dropdown-types';
import { GuidService } from 'ui-components/services/guid-service';

import Global from '../../../../../../store/global-selectors';
import type { WorkflowActionInputProps } from '../../../registries/registry-types';
import { messages } from '../messages';

const getOptionLabel = (option: DropdownOption) => option.name as string;
const getOptionValue = (option: DropdownOption) => String(option.fulfillmentServiceId);

export const FulfillmentServiceDropdown: React.FC<WorkflowActionInputProps> = ({ className, draft, onUpdate }) => {
  const intl = useIntl();
  const id = useMemo(() => GuidService.newGuid(), []);
  const services = useSelector(Global.selectSellerFulfillmentServices);

  const handleSelect = useCallback(
    (value: string) => {
      onUpdate({ intParameter: value ? Number(value) : null });
    },
    [onUpdate],
  );

  return (
    <SearchableDropdownField
      className={className}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      id={id}
      onItemSelected={handleSelect}
      options={services}
      placeholder={intl.formatMessage(messages.fulfillmentServiceDropdownPlaceholder)}
      selectedItemValue={draft.intParameter !== null ? String(draft.intParameter) : undefined}
    />
  );
};
